import React from "react";
import { CTAButton } from "@/components/landing/kit";
import { ASSETS, BAR_STATS, BAR_CTA } from "@/lib/site-data";

const AnnouncementBar = () => (
  <div
    data-testid="announcement-bar"
    className="flex w-full flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-[#2D5BFF] px-4 py-2 text-center text-white"
  >
    <p className="font-heading text-[11px] font-bold uppercase tracking-[0.16em] sm:text-xs">
      {BAR_STATS}
    </p>
    <span className="hidden text-white/50 sm:inline">|</span>
    <span className="inline-flex items-center gap-1.5 font-heading text-[11px] font-extrabold uppercase tracking-[0.16em] sm:text-xs">
      <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-white" />
      {BAR_CTA}
    </span>
  </div>
);

const SiteHeader = () => (
  <header
    data-testid="site-header"
    className="border-b border-[#E5E8F0] bg-white/90 backdrop-blur-md"
  >
    <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3 sm:px-6 lg:px-8">
      <a
        href="/"
        data-testid="header-logo"
        className="flex items-center gap-2"
        aria-label="DSA eCommerce home"
      >
        <img src={ASSETS.logo} alt="DSA eCommerce" className="h-8 w-auto sm:h-9" />
        <span className="hidden font-heading text-sm font-extrabold uppercase tracking-widest text-[#0F1117] sm:inline">
          eCommerce
        </span>
      </a>
      <CTAButton size="md" showArrow={false} testId="header-cta-button">
        Book a Call
      </CTAButton>
    </div>
  </header>
);

export const TopBar = () => (
  <div className="fixed inset-x-0 top-0 z-50">
    <AnnouncementBar />
    <SiteHeader />
  </div>
);

export default TopBar;
